import { useQuery } from "@tanstack/react-query";
import { RelabelCaseService } from "src/services";
import { queryKeys } from "src/constants";

export const useRelabelCasesByTransferOrderId = (transferOrderId: string, relabelCaseService: RelabelCaseService) => {
  const {
    data: relabelCases,
    error: fetchError,
    isLoading,
    refetch
  } = useQuery({
    queryKey: queryKeys.relabelCasesByTransferOrder(transferOrderId),
    queryFn: async () => await relabelCaseService.getRelabelCasesByTransferOrderId(transferOrderId),
    enabled: !!transferOrderId,
    retry: false
  });

  return { relabelCases, fetchError, isLoading, refetch };
};
